import axios from "axios";
export const getSmartCardData = async () => {
     // console.log('vvv');
      try {
          let token = window.sessionStorage.getItem("token");
          const config = {
            headers: { Authorization: `` },
          };
          let url_agent =  `https://localhost:8443/smartcard/data`;
          //let url_agent =  `http://localhost:8084/smartcard/data`;
          let event = await axios.get("https://localhost:8443/smartcard/data/", {
              
          })
          
          return { status: true, data: event.data };
        } catch (error) {
          let error_msg = "";
          if (error.response) {
            error_msg = error.response.data.msg;
          }
          return { status: false, data: error_msg };
        }
   
};

